import { getAxiosInstance } from "../../../api";

export const getDeliveryCertificate = async (id, slug) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(
      `delivery/recheck/list?receipt_id=${id}&process_slug=${slug}`,
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const approveCertificate = async (params) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`delivery/recheck/submit`, params);
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const getPrintSlip = async (id) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(`/delivery/recheck/slip?stock_receipt_id=${id}`);
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const getMultipleRecheckReissueSlip = async (stockReceiptIds) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/delivery/multiple-recheck-reissue-slip`, {
      stock_receipt_ids: stockReceiptIds,
    });
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const getPrintChellan = async (id) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(
      `/delivery/recheck/create-challan?stock_receipt_id=${id}`,
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};
export const getOrderPrintSlip = async (id) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(`/delivery/slip?stock_receipt_id=${id}`);
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const getOrderPrintChellan = async (id) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(
      `/delivery/create-challan?stock_receipt_id=${id}`,
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};
export const passRecheckAll = async (params) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(
      `/employee-dashboard/recheck/bulk-status-complete`,
      params,
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const uploadDeliveryChallan = async (params) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(`/delivery/recheck/recheck-delivery-challan-upload`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const downloadDeliveryRecheckExcel = async (receiptId, key) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(
      `/verification/recheck-excel-download`,
      { receipt_id: receiptId, key }
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const updateRecheckPrintData = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/delivery/recheck/update`, body);
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const getDeliveryStockReceiptSlip = async (stock_receipt_id) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(
      `/delivery/stock-receipt-slip?stock_receipt_id=${stock_receipt_id}`,
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const getDeliveryRecheckReissueStockReceiptSlip = async (
  recheck_stock_receipt_id,
) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(
      `/delivery/recheck-reissue-stock-receipt-slip?recheck_stock_receipt_id=${recheck_stock_receipt_id}`,
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};
